import { SDUITextRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITextRenderer";
import { EmptyStateSections } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/EmptyStateSections";
import {
  ISuggestionEntryMixin,
  ISuggestionEntry,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import { useLinkPrefetch } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/useLinkPrefetch";
import { getSuggestionUrl } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/utils";
import { ResultsDropdownSectionWrapper } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownSectionWrapper";
import { buildNaturalLanguageSuggestions } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/suggestionSectionBuilders";
import { isLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { getNaturalLanguageSearchEmptyStateHeader } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/consts";
import { ISDUIText } from "@faire/web-api--source/indigofair/data/ISDUIText";
import { ISlateTextStyle } from "@faire/web-api--source/indigofair/data/ISlateTextStyle";
import { TextDecorator } from "@faire/web-api--source/indigofair/data/TextDecorator";
import { TextJustification } from "@faire/web-api--source/indigofair/data/TextJustification";
import { TextStyleType } from "@faire/web-api--source/indigofair/data/TextStyleType";
import { useStrictLocalization } from "@faire/web/common/localization";
import { useCallback, useState } from "react";

export const NLSSuggestionsSection = ({
  suggestions,
  submit,
}: {
  suggestions: string[];
  submit: (query: string, submittedUrl?: string, navigate?: boolean) => void;
}) => {
  const { strictLocalize } = useStrictLocalization();
  const { prefetchUrl, clearLinkPrefetchTimeout } = useLinkPrefetch();
  const title = ISDUIText.build({
    slate_text_segments: [
      ISDUIText.ISDUITextSegment.build({
        slate_text: {
          content: getNaturalLanguageSearchEmptyStateHeader(strictLocalize),
          style: ISlateTextStyle.build({
            type: TextStyleType.PARAGRAPH,
            text_justification: TextJustification.START,
            decorators: [TextDecorator.EMPHASIS],
          }),
        },
        text_on_click: [],
      }),
    ],
  });
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const entryCount = suggestions.length;
  const handleSuggestionHover = useCallback(
    (selectedIdx: number, url?: string) => {
      if (selectedIdx < 0) {
        setSelectedIndex(-1);
        return;
      }
      if (selectedIdx >= entryCount) {
        setSelectedIndex(entryCount - 1);
      } else {
        setSelectedIndex(selectedIdx);
      }
      if (isLoggedInRetailer()) {
        prefetchUrl(url);
      }
    },
    [entryCount, prefetchUrl]
  );

  const onClick = useCallback(
    (suggestion: ISuggestionEntry) => {
      clearLinkPrefetchTimeout();
      submit(
        suggestion.searchData.query ?? "",
        getSuggestionUrl(suggestion.url),
        true
      );
    },
    [submit, clearLinkPrefetchTimeout]
  );

  const handleSuggestionBlur = useCallback(() => {
    setSelectedIndex(-1);
    clearLinkPrefetchTimeout();
  }, [clearLinkPrefetchTimeout]);

  const section = buildNaturalLanguageSuggestions(
    suggestions.slice(0, 2),
    getNaturalLanguageSearchEmptyStateHeader(strictLocalize),
    ""
  ) as ISuggestionEntryMixin[];

  return (
    <ResultsDropdownSectionWrapper
      sectionHeader={getNaturalLanguageSearchEmptyStateHeader(strictLocalize)}
      suggestionArray={section}
      sectionIndex={0}
      query=""
    >
      <div className="mx-5 mt-4 mb-1">
        <SDUITextRenderer text={title} />
      </div>
      {section.map((suggestion, index) => (
        <EmptyStateSections
          key={suggestion.url}
          sectionHeader={getNaturalLanguageSearchEmptyStateHeader(
            strictLocalize
          )}
          suggestion={suggestion}
          onHover={() => handleSuggestionHover(index, suggestion.url)}
          onMouseLeave={handleSuggestionBlur}
          onClick={() => onClick(suggestion)}
          onDelete={() => {}}
          selected={selectedIndex}
          indx={index}
          shouldEnableSuggestionsImpressionAllocationV2={false}
        />
      ))}
    </ResultsDropdownSectionWrapper>
  );
};
